export default "__VITE_ASSET__0jFOmuqf__"